import * as React from 'react';
import PropTypes from 'prop-types';
import {Header} from "semantic-ui-react";

const SectionHeader = ({children, as, style, ...props}) => (
	<Header as={as} style={{textAlign: 'center', ...style}} {...props}>{children}</Header>
);
SectionHeader.propTypes = {
	children: PropTypes.node,
	style: PropTypes.object,
	as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};
SectionHeader.defaultProps = {
	as: 'h3',
	style: {}
};

export default SectionHeader;


// WEBPACK FOOTER //
// ./src/components/SectionHeader.js